export const SHANE_BUYING = 'shaneBuying'
export const SHANE_SPILLING = 'shaneSpilling'
